export const ID_DEFINITION = {
	PRODUCT_PAGE: 'productPageLink',
	DATASHEET: 'datasheetLink',
	SIMILAR_PRODUCTS: 'simProduct',
	EVALUATION_BOARD: 'evalBoardLink',
	CASE_OUTLINE: 'caseOutlineLink',
	CASE_CAD: 'caseCad'
};

export const ID_GRAPH_AXIS = {
	X: 'X',
	Y1: 'Y1',
	Y2: 'Y2'
};

export default ID_DEFINITION;
